import React, { FC } from 'react';
import { OperatorPanelNoConnectorProps } from './OperatorPanelNoConnector';
import { ContentUnavailableCentralPart } from './ContentUnavailableCentralPart';
import UnavailableContent from './UnavailableContent';
import { font as initialFont } from '@styles/fonts';
import { TEST_IDS } from '@v2/pages/common/constants/base.constants';

interface OperatorPanelNotProductiveProps extends OperatorPanelNoConnectorProps {}

const OperatorPanelNotProductive: FC<OperatorPanelNotProductiveProps> = ({
  CC,
  machineName,
  isOperator,
  machineStatus,
  time,
  insetBottom,
  insetTop,
  scale,
  font = initialFont,
}) => {
  return (
    <UnavailableContent {...{ CC, machineName, machineStatus, isOperator, insetBottom, insetTop, scale, font, testID: TEST_IDS.operatorPanel.unavailable.notProductive }}>
      <ContentUnavailableCentralPart
        {...{
          CC,
          title: 'Not Productive',
          titleFont: 'Roboto Extra Large Title',
          titleColor: 'Label/Light/Always Light Tertiary',
          timeMarginTop: 18,
          timeFont: 'Large Title Normal',
          time,
          scale,
          font,
        }}
      />
    </UnavailableContent>
  );
};

export default OperatorPanelNotProductive;
